<script lang="ts">
export default {
  name: 'KkPostTitleText',
}
</script>
<script setup lang="ts">
import { computed } from 'vue'
import type { TopicType } from '../../types'

interface Props {
  topicType: TopicType
  postTitle?: string
  postEventTitle?: string
}
const props = defineProps<Props>()

const showTitleText = computed<boolean>(() => {
  return Boolean(props.postTitle) || Boolean(props.postEventTitle)
})

const titleText = computed<string>(() => {
  if (props.topicType === 'STANDARD') {
    return props.postTitle ?? ''
  }
  return props.postEventTitle ?? ''
})
</script>
<template>
  <h3 v-if="showTitleText" class="title">{{ titleText }}</h3>
</template>
<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';
.title {
  margin-bottom: 0;
  font-size: 14px;
  word-break: break-all;
}
</style>
